import type { ReactNode } from 'react';

interface OrderItemProps {
  children: ReactNode;
  className?: string;
}

export function OrderItem({ children, className }: OrderItemProps) {
  return (
    <div data-testid="orderItem" className={className}>
      {children}
    </div>
  );
}
